import React from 'react';

const DistanceIcon = () => {
  return (
    <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 0C17.69 0 16.58 0.83 16.17 2H13.82C13.4 0.84 12.3 0 11 0C9.7 0 8.6 0.84 8.18 2H5.83C5.42 0.83 4.31 0 3 0C1.34 0 0 1.34 0 3C0 4.66 1.34 6 3 6C4.31 6 5.42 5.17 5.83 4H8.18C8.6 5.16 9.7 6 11 6C12.3 6 13.4 5.16 13.82 4H16.17C16.58 5.17 17.69 6 19 6C20.66 6 22 4.66 22 3C22 1.34 20.66 0 19 0Z" fill="currentColor" />
    </svg>
  )
};

export default DistanceIcon;
